<input class="input is-shorter"
 [colorPicker]="DisplayValue" (colorPickerChange)="ValueChanged($event)" (change)="ManualUpdate($event)"
  [ngStyle]="{ 'background-color' : DisplayValue }" [ngClass]="ClassForColor()" [(ngModel)]="DisplayValue" >
